import { render } from "./SkeletonTile.vue?vue&type=template&id=6395bb84"
import script from "./SkeletonTile.vue?vue&type=script&lang=js"
export * from "./SkeletonTile.vue?vue&type=script&lang=js"

import "./SkeletonTile.vue?vue&type=style&index=0&id=6395bb84&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__